// Membership Button Handler - Include once in your theme
(function () {
  if (window.membershipButtonInitialized) return;
  window.membershipButtonInitialized = true;

  const MEMBERSHIP_HANDLE = "paid-membership";
  let upcartSubscriptionBound = false;

  const updateAllMembershipButtons = (isAdded = false, isLoading = false) => {
    const allButtons = document.querySelectorAll(".membership-button");
    const allSpinners = document.querySelectorAll(".membership-spinner");
    const allButtonTexts = document.querySelectorAll(".membership-button-text");

    allButtons.forEach((button) => {
      button.disabled = isAdded || isLoading;
    });

    allSpinners.forEach((spinner) => {
      if (isLoading) {
        spinner.classList.remove("tw:hidden");
      } else {
        spinner.classList.add("tw:hidden");
      }
    });

    allButtonTexts.forEach((buttonText) => {
      if (isLoading) {
        buttonText.textContent = "Adding to cart...";
      } else if (isAdded) {
        buttonText.textContent = "Added To Cart";
      } else {
        buttonText.textContent = buttonText.dataset.originalText || "Join the club";
      }
    });
  };

  const cartHasMembership = (cart) => {
    if (!cart || !Array.isArray(cart.items)) return false;

    return cart.items.some((item) => {
      return (
        item.handle === MEMBERSHIP_HANDLE ||
        item.product_handle === MEMBERSHIP_HANDLE ||
        item.url?.includes(`/products/${MEMBERSHIP_HANDLE}`)
      );
    });
  };

  const syncMembershipButtonsFromCart = (cart) => {
    updateAllMembershipButtons(cartHasMembership(cart), false);
  };

  const initializeMembershipButtons = () => {
    const membershipForms = document.querySelectorAll(".membership-form");
    if (!membershipForms.length) return;

    document.querySelectorAll(".membership-button-text").forEach((buttonText) => {
      if (!buttonText.dataset.originalText) {
        buttonText.dataset.originalText = buttonText.textContent.trim();
      }
    });

    membershipForms.forEach((form) => {
      if (form.dataset.membershipInitialized) return;
      form.dataset.membershipInitialized = "true";

      form.addEventListener("submit", async (event) => {
        event.preventDefault();

        updateAllMembershipButtons(false, true);
        let membershipWasAdded = false;

        try {
          const formData = new FormData(form);

          const response = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
          });

          if (!response.ok) {
            let message = "Failed to add membership to cart";
            try {
              const errorPayload = await response.json();
              if (errorPayload?.description) {
                message = errorPayload.description;
              }
            } catch (_parseError) {
              // Keep the fallback message if Shopify does not return JSON.
            }
            throw new Error(message);
          }

          await response.json();
          membershipWasAdded = true;

          if (typeof window.refreshCartContents === "function") {
            window.refreshCartContents();
          }

          if (typeof bootstrap !== "undefined" && bootstrap.Offcanvas) {
            const offcanvasCart = document.querySelector("#offcanvas-cart");
            if (offcanvasCart) {
              bootstrap.Offcanvas.getOrCreateInstance(offcanvasCart)?.show();
            }
          }

          // Let UpCart subscription update the final state
        } catch (error) {
          if (membershipWasAdded) {
            console.warn("Membership was added, but post-add UI update failed:", error);
            return;
          }

          console.error("Error adding membership to cart:", error);
          alert("There was an error adding the membership to your cart. Please try again.");
          updateAllMembershipButtons(false, false);
        }
      });
    });
  };

  const bindUpcartSubscription = () => {
    if (upcartSubscriptionBound) return;

    if (typeof window.upcartSubscribeCartUpdated !== "function") {
      console.error("UpCart API unavailable: window.upcartSubscribeCartUpdated is not defined");
      return;
    }

    window.upcartSubscribeCartUpdated(({ cart }) => {
      syncMembershipButtonsFromCart(cart);
    });

    upcartSubscriptionBound = true;
    console.log("UpCart cart subscription bound");
  };

  const init = () => {
    initializeMembershipButtons();
    bindUpcartSubscription();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initializeMembershipButtons, { once: true });
  } else {
    initializeMembershipButtons();
  }

  // Important: wait until full page/app load before binding UpCart API
  window.addEventListener("load", init, { once: true });

  const observer = new MutationObserver(() => {
    initializeMembershipButtons();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
